import * as React from "react";
import { useEffect } from "react";
import ScrollBar from "react-perfect-scrollbar";
import { ScrollOptions } from "../../../constants/ScrollOptions";
import { utilCompatibility } from "../../../utils/utilCompatibility";
import { IdTooltipAnchor, TooltipText } from "../../tooltip";
export var GridLayout = React.memo(function (_a) {
    var GridItem = _a.gridItemRenderer, items = _a.items, onClick = _a.onClick, selectedItemIndex = _a.selectedItemIndex;
    var refToSelectedIndex = React.createRef();
    var refToItemsContainer;
    var gridItem = function (item, index) {
        var isItemSelected = selectedItemIndex === index;
        var gridItemStateClass = isItemSelected ? "selected" : "";
        var selectedItemRef = isItemSelected ? refToSelectedIndex : undefined;
        // For IE
        var gridStyle = utilCompatibility.getMsGridPositions(index, 3);
        return (React.createElement("div", { style: gridStyle, className: "grid-element", key: index, ref: selectedItemRef },
            React.createElement(TooltipText, { id: item.locaKey, replacements: item.replacements, anchor: IdTooltipAnchor.Bottom, key: index },
                React.createElement(GridItem, { item: item, className: gridItemStateClass, onClick: function () { return onClick(index); } }))));
    };
    var gridItems = items.map(gridItem);
    // componentDidMount
    useEffect(function () {
        if (!!refToItemsContainer && !!refToSelectedIndex && !!refToSelectedIndex.current) {
            var selectedElement = refToSelectedIndex.current;
            refToItemsContainer.scrollTop =
                selectedElement.offsetTop - refToItemsContainer.offsetTop;
        }
    });
    return (React.createElement(ScrollBar, { component: "div", options: ScrollOptions, containerRef: function (ref) { return (refToItemsContainer = ref); }, className: "w100" },
        React.createElement("div", { className: "grid-layout" }, gridItems)));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/grid-layout/GridLayout.tsx
// module id = 2599
// module chunks = 3